<div class="ag-selection-checkbox">
  <div
    class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
    [ngClass]="{ 'ag-checked': isChecked }"
  >
    <input
      id="select-individual-order"
      type="checkbox"
      class="select-order ag-input-field-input ag-checkbox-input"
      [checked]="isChecked"
      (change)="changeSelection()"
    />
  </div>
</div>
